(function () {
    'use strict';
    angular.module('finansApp.employeeFilterController', []).controller('employeeFilterController', employeeFilterController);
    
    employeeFilterController.$inject = ['employeeService'];


    function employeeFilterController(employeeService) {
        var vm = this;
        vm.state = employeeService.state;
        vm.state.showFilter = 0;
        vm.state.mobileFilter = false;
        var $body = $('body');

      
        vm.toggleFilter = function(filterType) {

            if(filterType !== vm.state.showFilter) {
                vm.state.showFilter = filterType;
            } else {
                vm.state.showFilter = 0; 
            }


        }

        vm.toggleMobileFilter = function() {
            toggleOverlay();
        }

        vm.resetFilter = function() {
            vm.state.selectedDepartments = {};
            vm.state.selectedSubjects = {};
            vm.state.searchQuery = "";

            employeeService.filterEmployees()
        }

        vm.removeFilter = function(id, obj) {
            delete obj[id];

            employeeService.filterEmployees()
        }

        vm.changeFilter = function(id, name, filterTypeID) {
            var obj;

            if(filterTypeID == 3129) {
                obj = vm.state.selectedDepartments;
            } else if (filterTypeID == 3130) {
                obj = vm.state.selectedSubjects;
            } else {
                obj = [];
            }


            if(typeof (obj[id]) === 'undefined' && !obj[id]) {
                obj[id] = name;
            } else {
                delete obj[id];
            }


            // Filter the array of employees
            employeeService.filterEmployees()

        }


        function toggleOverlay() {

            if($body.hasClass('open-overlay')) {
                $body.removeClass('open-overlay');
            } else {
                $body.addClass('open-overlay');
            }
        }

    }

})();